<template>
  <b-container>
    <div style="position: fixed; top: 0px; left: 0px; z-index: 99999">
    </div>
    <evaluation-node-information
      :requirement="getSelectedRequirement"
      :status="getSavingStatus"
    >
      <template #title>
        <h4 class="text-left">
          {{ $t("label_evaluation_requirementEvaluation_requirementCard") }}
        </h4>
      </template>
      <template #description>
        <div style="margin-top: 20px" class="disclaimer">
          {{ $t("label_evaluation_evidencesRequested_evidences_description") }}
        </div>
      </template>
      <template #additionalTemplate>
        <div
          v-if="evaluation_administrator_node_matrix_dimension"
          style="justify-content: left"
          class="col-h4"
        >
          <div class="subTitle">
            {{ $t("label_evaluation_requirementEvaluation_dimension") }}
          </div>
          {{ $t(evaluation_administrator_node_matrix_dimension) }}
        </div>
        <div
          v-if="evaluation_administrator_node_matrix_indicator_indicator"
          class="col-h4"
          style="justify-content: left"
        >
          <div class="subTitle">
            {{ $t("label_evaluation_requirementEvaluation_relatedIndicators") }}
          </div>
          <span v-if="evaluation_administrator_node_matrix_indicator_indicator">
            {{ evaluation_administrator_node_matrix_indicator_indicator.id }}
            -
            {{
              $t(evaluation_administrator_node_matrix_indicator_indicator.name)
            }}</span
          >
        </div>
        <div
          v-if="evaluation_administrator_node_matrix_indicator_indicator"
          class="col-h4"
          style="justify-content: left"
        >
          <div class="subTitle">
            {{ $t("label_evaluation_requirementEvaluation_indicatorValue") }}
          </div>
          <span v-if="evaluation_administrator_node_matrix_indicator_indicator">
            {{
              getIndicatorValue(
                evaluation_administrator_node_matrix_indicator_indicator.value
              )
            }}
          </span>
        </div>
        <div
          v-if="
            getSelectedRequirement.evaluation_administrator_node_matrix_notes
          "
          class="col-h4"
          style="justify-content: left"
        >
          <div class="subTitle">
            {{ $t("label_evaluation_requirementEvaluation_notes") }}
          </div>
          {{
            getSelectedRequirement.evaluation_administrator_node_matrix_notes
          }}
        </div>

        <div class="evidenceFilePadding">
          {{
            getSelectedRequirement.evaluation_administrator_node_editRequirement_describeEvidenceRequired
          }}
        </div>

        <b-container fluid="md" style="margin-top: 20px; margin-bottom: 20px">
          <b-row class="d-flex justify-content-center">
            <div class="d-flex justify-content-around">
              <b-col>
                <b-button
                  style="width: 280px; margin-top: 0px"
                  variant="primary"
                  :disabled="isReadOnly()"
                  @click="showModal = true"
                >
                  {{ $t("label_evaluation_evidencesRequested_upload_button") }}
                </b-button>
              </b-col>
              <b-col>
                <b-button
                  style="width: 285px"
                  class="secondary-button"
                  :disabled="isReadOnly()"
                  @click="showRelatedEvidencesModal = true"
                >
                  {{
                    $t(
                      "label_evaluation_evidencesRequested_useEvidenceAlreadySubmitted_button"
                    )
                  }}
                </b-button>
              </b-col>
              <b-col>
                <b-button
                  style="width: 280px"
                  class="secondary-button"
                  :disabled="isReadOnly()"
                  @click="showJustificationModal = true"
                >
                  {{
                    $t(
                      "label_evaluation_evidencesRequested_evidenceNotAvailable_button"
                    )
                  }}
                </b-button>
              </b-col>
            </div>
          </b-row>
        </b-container>
        <div>
          <template-uploaded-files
            :evaluation-id="evaluationId"
            :can-delete="true"
            :evidences="ownedEvidences"
            @openDeleteModal="openDeleteModal"
          >
            <template #title>
              {{
                $t(
                  "label_evaluation_evidencesRequested_evidencesUploaded_subtitle"
                )
              }}
            </template>
          </template-uploaded-files>

          <template-uploaded-files
            :evaluation-id="evaluationId"
            :can-delete="true"
            :evidences="linkedEvidences"
            @openDeleteModal="openDeleteModal"
          >
            <template #title>
              {{
                $t(
                  "label_evaluation_evidencesRequested_evidencesLinked_subtitle"
                )
              }}
            </template>
          </template-uploaded-files>

          <template-uploaded-files
            :key="
              getSelectedRequirement &&
              getSelectedRequirement.evidences &&
              getSelectedRequirement.evidences.comments &&
              getSelectedRequirement.evidences.comments.length
            "
            :evaluation-id="evaluationId"
            :can-delete="true"
            :requirement="getSelectedRequirement"
            @openDeleteModal="openDeleteModal"
          >
            <template #title>
              {{
                $t(
                  "label_evaluation_evidencesRequested_evidencesLinked_subtitle"
                )
              }}
            </template>
          </template-uploaded-files>
        </div>
        <b-row
          v-if="
            !isReadOnly() &&
            getSelectedRequirement.evaluation_administrator_node_editRequirement_evidencesReady !==
              'label_evaluation_evidencesRequested_status_resubmit'
          "
        >
          <b-col class="col-h4" cols="7">
            <div class="subTitle" style="margin-top: 10px">
              {{ $t("label_evaluation_evidencesRequested_status") }}
            </div>
            <template-tooltip
              tooltip="label_evaluation_evidencesRequested_status_tooltip"
            />
            <b-form-select
              id="modelabel_evaluation_administrator_node_matrix_indicator"
              v-model="evidenceIsReady"
              style="width: 100%; margin-left: 10px"
              @change="updateEvidenceStatus($event)"
            >
              <option
                v-for="(option, optionIndex) of options"
                :key="optionIndex"
                :value="option.value"
              >
                {{ $t(option.label) }}
              </option>
            </b-form-select>
          </b-col>
        </b-row>
      </template>
    </evaluation-node-information>
    <template v-if="getSelectedRequirement.comments">
      <evaluation-node-comments
        :requirement="getSelectedRequirement"
        :is-organization="true"
      >
        <template #title>
          <h4 class="text-left">
            {{
              $t("label_evaluation_requirementEvaluation_evaluationComments")
            }}
          </h4>
        </template>
      </evaluation-node-comments>
    </template>
    <evaluation-organization-upload-file-modal
      :show-modal.sync="showModal"
      :requirement="getSelectedRequirement"
      :evaluation-id="evaluationId"
      @newData="attachEvidences"
    />
    <evaluation-organization-delete-evidence-modal
      :show-modal.sync="showModal1"
      :evidence="evidenceToDelete"
      :evidences="ownedEvidences"
      :requirement-id="getSelectedRequirement.id"
      @deleteFile="deleteFile"
    />
    <evaluation-organization-related-evidences-modal
      :show-modal.sync="showRelatedEvidencesModal"
      :requirement.sync="getSelectedRequirement"
      :evaluation-id="evaluationId"
      @newData="attachEvidences"
    />
    <evaluation-organization-evidence-justification-modal
      :show-modal.sync="showJustificationModal"
      :requirement.sync="getSelectedRequirement"
      :account="account"
      @newData="setStatus"
    />
  </b-container>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import EvaluationNodeInformation from "../shared/EvaluationNodeInformation.vue";
// import EvaluationNodeComments from "./EvaluationNodeComments.vue";
import EvaluationOrganizationDeleteEvidenceModal from "./EvaluationOrganizationDeleteEvidenceModal.vue";
import EvaluationOrganizationUploadFileModal from "./EvaluationOrganizationUploadFileModal.vue";
import EvaluationOrganizationEvidenceJustificationModal from "./EvaluationOrganizationEvidenceJustificationModal.vue";
import EvaluationOrganizationRelatedEvidencesModal from "./EvaluationOrganizationRelatedEvidencesModal.vue";
import evaluationDataMixin from "@/components/modules/evaluation/mixins/evaluationDataMixin";
import EvaluationNodeComments from "@/components/modules/evaluation/shared/EvaluationNodeComments";
import { axiosCall } from "@/utils/axiosCall";

export default {
  name: "EvaluationEvaluateNodeOrganization",
  components: {
    EvaluationNodeInformation,
    EvaluationNodeComments,
    EvaluationOrganizationDeleteEvidenceModal,
    EvaluationOrganizationUploadFileModal,
    EvaluationOrganizationEvidenceJustificationModal,
    EvaluationOrganizationRelatedEvidencesModal,
  },
  mixins: [evaluationDataMixin],
  computed: mapGetters([
    "getLang",
    "getSelectedRequirement",
    "getSavingStatus",
  ]),
  props: {
    evaluationId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      ownedEvidences: [],
      linkedEvidences: [],
      showModal: false,
      evidenceIsReady: null,
      improvement: {},
      evidenceToDelete: null,
      showModal1: false,
      showJustificationModal: false,
      showRelatedEvidencesModal: false,
      evaluationStatus: null,
      options: [
        {
          value: "label_evaluation_evidencesRequested_status_pending",
          label: "label_evaluation_evidencesRequested_status_pending",
        },
        {
          value: "label_evaluation_evidencesRequested_status_inProgress",
          label: "label_evaluation_evidencesRequested_status_inProgress",
        },
        {
          value: "label_evaluation_evidencesRequested_status_ready",
          label: "label_evaluation_evidencesRequested_status_ready",
        },
      ],
      evaluation_administrator_node_matrix_indicator_indicator: null,
      evaluation_administrator_node_matrix_dimension: null,
    };
  },
  watch: {
    getSelectedRequirement: async function () {
      await this.fillRequirementInfo();
      this.evidenceIsReady =
        this.getSelectedRequirement.evaluation_administrator_node_editRequirement_evidencesReady;
      await this.loadEvidences();
    },
    /*    "requirement.evaluation_status": async function () {
          this.$store.commit("setLastEvaluated", this.requirement.id);
          // eslint-disable-next-line camelcase
          this.requirement.evaluation_last_updated = new Date().toLocaleDateString("en-US");
          this.requirement.userAccount = this.account;
          this.$emit('saveAndForce')
          },*/
    /*    "requirement.evaluation_administrator_node_editRequirement_evidencesReady": function () {
          this.$emit('saveAndForce', true)
        }*/
  },
  mounted: async function () {

    await this.fillRequirementInfo();
    this.evidenceIsReady =
      this.getSelectedRequirement.evaluation_administrator_node_editRequirement_evidencesReady;
    await this.loadEvidences();

  },
  destroyed: function () {
    this.$emit("clearEvaluatingNode");
  },
  methods: {
    updateEvidenceStatus: async function (newStatus) {
      await this.setStatus(newStatus);
    },
    loadEvidences: async function () {
      await axios
        .get(
          `/Evidences/${this.evaluationId}/${this.getSelectedRequirement.id}`
        )
        .then((response) => {
          this.ownedEvidences = response.data.owned;
          this.linkedEvidences = response.data.linked;
        });
    },
    addNewEvidence() {
      this.loadEvidences();
      this.setStatus("label_evaluation_evidencesRequested_status_inProgress");
    },
    async attachEvidences() {
      await this.setStatus(
        "label_evaluation_evidencesRequested_status_inProgress"
      );
      await this.loadEvidences();
    },
    async setStatus(status) {
      let updateValues = {
        evaluation_administrator_node_editRequirement_evidencesReady: status,
        resubmission:
          this.getSelectedRequirement
            .evaluation_administrator_node_editRequirement_evidencesReady ===
          "label_evaluation_evidencesRequested_status_resubmit",
      };
      await this.$store.dispatch("updateEvaluation", {
        valuesToUpdate: updateValues,
        checkReadyToSend: true,
      });
    },
    isReadOnly() {
      return [
        "label_evaluation_evidencesRequested_status_submitted",
        "label_evaluation_evidencesRequested_status_resubmitted",
      ].includes(
        this.getSelectedRequirement
          .evaluation_administrator_node_editRequirement_evidencesReady
      );
    },
    encodeName(name) {
      return encodeURIComponent(name);
    },
    /*  updateLastUpdated (lastUpdated) {
        this.$emit('updateLastUpdated', lastUpdated)
        this.$emit('saveAndForce')
      },
      saveAndForce () {
        // eslint-disable-next-line camelcase
        this.getSelectedRequirement.evaluation_last_updated = new Date().toLocaleDateString('en-US')
        this.getSelectedRequirement.userAccount = this.account
        this.$emit('update:requirement', this.requirement)
        this.$emit('updateLastUpdated', this.requirement.id)
        this.$emit('saveAndForce')
      },

      postImprovement () {
        if (typeof this.getSelectedRequirement.improvements === 'undefined') {
          this.getSelectedRequirement.improvements = []
        }
        this.improvement.account = this.account
        this.improvement.date = new Date().toLocaleDateString('en-US')
        this.getSelectedRequirement.improvements.push(this.improvement)
        this.improvement = { ...{}}
        this.saveAndForce()
      },
      uuidv4 () {
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = Math.random() * 16 | 0
          // eslint-disable-next-line eqeqeq
          const v = c == 'x' ? r : (r & 0x3 | 0x8)
          return v.toString(16)
        })
      },*/
    getIndicatorValue(value) {
      if (isNaN(value)) {
        return value;
      } else {
        return Number(value).toFixed(2);
      }
    },
    async fillRequirementInfo() {
      if (this.getSelectedRequirement) {
        this.evaluation_status = this.getSelectedRequirement.evaluation_status;
        this.evaluation_administrator_node_matrix_dimension = null;
        this.evaluation_administrator_node_matrix_indicator_indicator = null;
        if (
          this.getSelectedRequirement
            .evaluation_administrator_node_matrix_indicator
        ) {
          // eslint-disable-next-line camelcase
          const data = {
            evaluationId: this.evaluationId,
            indicatorAcronym:
              this.getSelectedRequirement
                .evaluation_administrator_node_matrix_indicator,
          };
          await axiosCall({
            url: "Pillars/getIndicatorValue",
            method: "POST",
            data,
          }).then((response) => {
            // eslint-disable-next-line camelcase
            this.evaluation_administrator_node_matrix_dimension =
              response.data.pillar.id +
              " - " +
              this.$t(response.data.pillar.name);
            // eslint-disable-next-line camelcase
            this.evaluation_administrator_node_matrix_indicator_indicator =
              response.data.indicator;
          });
        }
      }
    },
    downloadFile: async function (fileName) {
      await axios
        .get(`/Evaluations/downloadEvidence/${this.evaluationId}/${fileName}`)
        .then((response) => {
          const link = document.createElement("a");
          link.setAttribute("style", "display: none");
          link.href = response.data;
          link.target = "_blank";
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    openDeleteModal(evidence) {
      this.evidenceToDelete = evidence;
      this.showModal1 = true;
    },
    deleteFile() {
      this.loadEvidences();
      this.showModal1 = false;
    },
  },
};
</script>
<style lang="scss">
@import "../../../../assets/css/variables";

h4 {
  font-size: 1.3rem;
  text-transform: uppercase;
}

.modal {
  text-align: center;

  .modal-title {
    width: 100%;
  }
}

.cardContainer {
  margin-bottom: 15px;
  font-size: 1rem;
}

.subTitle {
  font-size: 1.1rem;
  font-weight: bold;
  text-transform: uppercase;
  padding-right: 10px;
}

.commentContainer {
  margin: 30px 0px;
}

.commentText {
  padding: 10px 0px;
  text-align: justify;
}

.commentContext {
  font-weight: bold;
  border-bottom: 1px solid #636363;
}

.evidenceFilePadding {
  margin-top: 5px;
  margin-bottom: 5px;
}

.secondary-button {
  border-color: $primary-color;
  background-color: $third-color;
  color: $primary-color;
  border-radius: 10px;
}
</style>
